// src/analytics-event-handler.ts
var isAnalyticsEventHandlerAvailable = function() {
    return typeof window !== "undefined" && Boolean(window === null || window === void 0 ? void 0 : window.AnalyticsEventHandler);
};
function analyticsEventHandler() {
    return {
        enabled: isAnalyticsEventHandlerAvailable(),
        sendMoEngageEvent: function(eventName, payload) {
            var _window_AnalyticsEventHandler, _window_AnalyticsEventHandler_sendMoEngageEvent;
            return window === null || window === void 0 ? void 0 : (_window_AnalyticsEventHandler = window.AnalyticsEventHandler) === null || _window_AnalyticsEventHandler === void 0 ? void 0 : (_window_AnalyticsEventHandler_sendMoEngageEvent = _window_AnalyticsEventHandler.sendMoEngageEvent) === null || _window_AnalyticsEventHandler_sendMoEngageEvent === void 0 ? void 0 : _window_AnalyticsEventHandler_sendMoEngageEvent.call(_window_AnalyticsEventHandler, eventName, payload);
        }
    };
}
export { analyticsEventHandler };
